// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-pX7T","file-dropzone":"styles_file-dropzone__dawMT","fileDropzone":"styles_file-dropzone__dawMT"};